import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    ContactPageFragment,
    GetContact as GetContactQuery,
    GetContactVariables,
} from 'nutshell-graphql-types';

import GET_CONTACT from '../queries/get-contact.graphql';

export function useGetContact(
    contactId: string,
    skip: boolean = false
): {
    contact: ContactPageFragment | null;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} {
    const {data, loading, error, refetch} = useQuery<GetContactQuery, GetContactVariables>(
        GET_CONTACT,
        {
            variables: {id: contactId},
            notifyOnNetworkStatusChange: true,
            fetchPolicy: 'cache-and-network',
            skip,
        }
    );

    return {
        contact: data?.contact ?? null,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
}
